<template>
    <div>
        
        <a-result :style="{ marginTop: '-50px' }">
            <template #icon></template>
            <template #title>
                <p style="font-size: 20px;" class="mt-0 mb-0">Download <b><span
                            style="color: #610C9F !important;">IC-APP</span></b> Mobile Application</p>
            </template>
            <template #subTitle>
                
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a href="https://apps.apple.com/app/ic-app/id6469416277" target="_blank" rel="noopener noreferrer">
                            <a-card>
                                <p class="mt-0 mb-0">Available on the</p>
                                <p class="btn-load mt-0 mb-0"><a-icon type="apple" class="mr-5" />App Store</p>
                            </a-card>
                        </a>
                    </a-col>
                    <a-col :span="12">
                        <a href="https://play.google.com/store/apps/details?id=muic.inhouse.icapp" target="_blank"
                            rel="noopener noreferrer">
                            <a-card>
                                <p class="mt-0 mb-0">Get it on the</p>
                                <p class="btn-load mt-0 mb-0"><a-icon type="android" class="mr-5" />Google Play</p>
                            </a-card>
                        </a>
                    </a-col>
                </a-row>
                
            </template>
            
            
        </a-result>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {}
}
</script>

<style scoped>
.desc p {
    margin-bottom: 1em;
    text-align: 'center';
}

.btn-load {
    font-size: 14px;
    font-weight: 700;
    color: black;
}</style>